module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagMappingActionRightInput.AddNewTagAction.right":"Value","tagMappingActionRightInput.CopyValue.right":"Target Key","tagMappingActionRightInput.RemoveTag.right":"Remove","tagMappingActionRightInput.Markup.right":"Markup %"}}')
  delete Component.options._Ctor
}
